// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".XHRReport-module__relativeBox___zJIuK{position:relative}.XHRReport-module__absoluteCopyBtn___kBWH2{position:absolute;right:8px;top:8px}", "",{"version":3,"sources":["webpack://./src/components/SPSocketLab/components/ConnectedData/components/XHRReport/XHRReport.module.scss"],"names":[],"mappings":"AAAA,uCACE,iBAAA,CAEF,2CACE,iBAAA,CACA,SAAA,CACA,OAAA","sourcesContent":[".relativeBox {\n  position: relative;\n}\n.absoluteCopyBtn {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"relativeBox": "XHRReport-module__relativeBox___zJIuK",
	"absoluteCopyBtn": "XHRReport-module__absoluteCopyBtn___kBWH2"
};
export default ___CSS_LOADER_EXPORT___;
